import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import '../../index.css'

/**
 * View for dialogmasks, such as new transaction input
 * @param {any} handleShow handles showing/closing of modal
 * @param {any} handleClose handles closing the modal
 * @param {any} handleSubmit handles submit of parent component when save button is clicked
 * @param {any} reload handles possible neccessary reload for parent component if modal is closed
 * @param {string} modalTitle string as modal title
 * @param {any} modalBody main content of modal as string or component
 * @param {string} formTitle acts as id for the invoking form, neccessary if submit is tied to a component in a different layer
 * @param {boolean} extendedView indicates whether modal should be represented with different layout
 * @param {boolean} isDraftModal indicated whether the modal displays a draft
 * @param {any} handleSave used as second handleSubmit parameter for drafts to be saved temporarily
 * @param {boolean} disabled indicates if submit button should be disabled
 */
const ModalView = ({ handleShow, handleClose, handleSubmit, reload, modalTitle, modalBody, formTitle, extendedView = false, isDraftModal = false, handleSave = null, disabled = false }) => {
    if (extendedView == true) {
        return (ExtendedModalView({ handleShow, handleClose, reload, modalTitle, modalBody, formTitle, disabled }))
    } else {
        return (
            <Modal show={handleShow}
                onHide={handleClose} onExit={reload}
                backdrop="static" className="modal-biggerButtons" className={formTitle}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>

                <Modal.Body>{modalBody}</Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Abbrechen</Button>
                    {isDraftModal && <Button form={formTitle} type="submit" variant="secondary" onClick={handleSave}>{window.i18n('saveDraft')}</Button>}
                    <Button form={formTitle} type="submit" variant="secondary" onClick={handleSubmit}>{isDraftModal ? window.i18n('dispatchDelivery') : window.i18n('save')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

//for params, see above
const ExtendedModalView = ({ handleShow, handleClose, reload, modalTitle, modalBody, formTitle, disabled }) => {
    return (
        <Modal show={handleShow}
            onHide={handleClose} onExit={reload}
            backdrop="static" dialogClassName="tablet-modal">
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>

            <Modal.Body>{modalBody}</Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Abbrechen</Button>
                <Button form={formTitle} type="submit" variant="secondary" disabled={disabled}>{window.i18n('confirm')}</Button>
            </Modal.Footer>
        </Modal>
    )
}

export { ModalView }